import { createAction } from 'redux-actions';
import { SEED_THREAD_HISTORY } from '../constants/actionTypes';
export const seedThreadHistory = createAction(SEED_THREAD_HISTORY);